import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";

const VelocityExplanation = () => {
  const { t } = useTranslation("coaching-portal");
  return (
    <Modal
      title={t("velocityExplanation.title")}
      className={"velocity-explanation-modal"}
    >
      <div className="body">
        <p className="p5">{t("velocityExplanation.paragraph1")}</p>
        <p className="p5 mt-2">{t("velocityExplanation.paragraph2")}</p>
        <p className="p5 mt-2">{t("velocityExplanation.paragraph3")}</p>
        <p className="p5 mt-2 mb-6">{t("velocityExplanation.paragraph4")}</p>
      </div>
    </Modal>
  );
};

export default VelocityExplanation;
